
import { defineComponent, computed } from 'vue';
import { isHexCode } from '@/utils/validators';
import MaterialIcon from '@/components/MaterialIcon.vue';

export default defineComponent({
  name: 'Button',
  components: {
    MaterialIcon
  },
  props: {
    iconActiveColor: {
      type: String,
      required: false,
      default: '#a7a7a7',
      validator: (value: string) => isHexCode(value)
    }
  },
  setup({ iconActiveColor }) {
    const activeColor = computed(() => ({ '--active-color': iconActiveColor }));

    return {
      activeColor
    };
  }
});
